
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Highlight from "../common/Highlight";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import GalleryItem from "../common/GalleryItem";
import { IGallery } from "../../../../../services";
import styles from "../../assets/style.module.css";

export interface FanArenaProps {
    basePath: string;
    gallery: IGallery[];
}

function FanArena({ basePath, gallery }: FanArenaProps) {

    const labels = i18nManager.Labels.home;

    return (<section className={styles["arena"]}>
        <div className={styles["container"]}>
            <h2 className={styles["arena-title"]}><Highlight text={labels.we_will} /></h2>
            <span className={styles["subtitle"]}>{labels.fan_arena}</span>
            <div className={styles["linkbar"]}>
                <span className={styles["linkbar-text"]}>{labels.watch_latest}</span>
                <span className={styles["linkbar-border"]} />
                <ReactRouterDom.NavLink to={pagePath(basePath, "GALLERY")} className={styles["linkbar-link"]}>{labels.view_gallery} <i className="fa fa-angle-double-right" /></ReactRouterDom.NavLink>
            </div>
            <div className={styles["arena-grid"]}>
                {gallery.slice(0, 5).map((g) => (<GalleryItem key={g.external_id} gallery={g} />))}
            </div>
        </div>
    </section>);
}

export default FanArena;
